module.exports = __webpack_public_path__ + "images/bug_orange_large_4d377b1235811744b944b70ac08e093d.png";